import { useField } from 'formik';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { useTheme } from "@mui/material";


const SelectInputNew = ({ label, options = [], ...props }) => {
  const [field, meta] = useField(props);
   const theme = useTheme();

// ✅ Pull out 'name' (already consumed by useField) so it doesn't override field spread
  const { name, ...restProps } = props;


  return (
   
      <TextField
        select
        label={label}
        size="small"
        fullWidth
        variant="outlined"
        margin="normal"
        //value={value ?? field.value}   // ✅ controlled properly
        //onChange={onChange ?? field.onChange} // ✅ ensure handler fires
        {...field}       // value, onChange, onBlur, name — from Formik
        {...restProps}   // everything else EXCEPT name
        error={meta.touched && Boolean(meta.error)}
        helperText={meta.touched && meta.error ? meta.error : ''}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              sx: {
                backgroundColor:
                  theme.palette.mode === 'dark'
                    ? theme.palette.greydark.C800
                    : theme.palette.grey.C200,
                color:
                  theme.palette.mode === 'dark'
                    ? theme.palette.common.white
                    : theme.palette.common.black,
                borderRadius: 2,

              },
            },
          },
        }}
        sx={{
          "& .MuiInputBase-input": {
            borderRadius: '18px',
            color: theme.palette.mode === 'dark'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
            fontWeight: 400,
          },
          "& .MuiInputLabel-root": {
            color: theme.palette.text.secondary,
            fontWeight: 400,
            fontSize: '0.9rem',
          },
          "& .MuiSelect-select": {
            color:
              theme.palette.mode === 'dark'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            fontWeight: 400,
          },
          "& .MuiOutlinedInput-root": {
            backgroundColor: theme.palette.background.default,
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[900],
              borderWidth: 2,
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            sx={{
              color: theme.palette.mode === 'dark' ? 'common.white' : 'common.black',
              fontWeight: 400,
              '&:hover': { bgcolor: theme.palette.mode === 'dark' ? 'greydark.C700' : 'grey.100' },
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    
  );
};

export default SelectInputNew;
